import React, { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Trash2 } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

export const SavedSearches = () => {
  const [savedSearches, setSavedSearches] = useState<any[]>([]);
  const { toast } = useToast();
  const isMobile = useIsMobile();

  useEffect(() => {
    fetchSavedSearches();
  }, []);

  const fetchSavedSearches = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data, error } = await supabase
        .from('saved_law_searches')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      setSavedSearches(data || []);
    } catch (error) {
      console.error('Error fetching saved searches:', error);
    }
  };

  const handleDelete = async (id: string, e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      const { error } = await supabase
        .from('saved_law_searches')
        .delete()
        .eq('id', id);

      if (error) throw error;

      setSavedSearches(savedSearches.filter(search => search.id !== id));
      toast({
        title: "Søk slettet",
        description: "Ditt lagrede søk har blitt slettet",
      });
    } catch (error) {
      console.error('Error deleting search:', error);
      toast({
        title: "Feil ved sletting",
        description: "Kunne ikke slette søket. Prøv igjen senere.",
        variant: "destructive",
      });
    }
  };

  const handleSearchClick = (search: any) => {
    const searchEvent = new CustomEvent('showSavedSearch', {
      detail: {
        content: search.content,
        title: search.title,
        sources: search.metadata?.sources || []
      }
    });
    window.dispatchEvent(searchEvent);

    toast({
      title: "Viser søk",
      description: "Ditt lagrede søk vises nå",
    });
  };

  if (savedSearches.length === 0) return null;

  return (
    <div className="mt-4 space-y-2">
      <h3 className="text-sm md:text-base font-medium text-gray-700">
        Lagrede søk {!isMobile && `(${savedSearches.length})`}
      </h3>
      <div className="grid gap-2">
        {savedSearches.map((search) => (
          <div
            key={search.id}
            onClick={() => handleSearchClick(search)}
            className="p-3 border rounded-lg bg-white hover:shadow-sm transition-all duration-200 cursor-pointer"
          >
            <div className="flex justify-between items-center gap-2">
              <span className="text-sm text-gray-800 truncate">
                {search.title}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={(e) => handleDelete(search.id, e)}
                className="h-8 w-8 p-0"
              >
                <Trash2 className="h-4 w-4 text-gray-500" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};